export function CreateVoiceIcon({
  className = "w-6 h-6",
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4063_1154)">
        <rect x="1.4" y="1.4" width="25.1999" height="25.1999" rx="12.5999" fill="#F4EBFF" />
        <rect x="1.4" y="1.4" width="25.1999" height="25.1999" rx="12.5999" stroke="#F9F5FF" stroke-width="2.8" />
        <path d="M7.24988 12.4996L7.24988 15.4994M10.6247 9.49975L10.6247 18.4992M13.9995 7.24988V20.7491M17.3743 9.49975V18.4992M20.7491 12.4996V15.4994" stroke="#7542F7" stroke-width="1.49991" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4063_1154">
          <rect width="28" height="28" fill="white" />
        </clipPath>
      </defs>
    </svg>

  );
}

export const displayName = "CreateVoiceIcon";
